import { sendQuizStepEvent } from '../../scripts/config/analytics';
import {
  QUIZ_EVENT_CATEGORY,
  ACTIONS,
  PRODUCTS,
} from '../../scripts/config/constants';
import { formatPriceWithoutZeros } from '../../scripts/utils/product-helpers';
import { initCart, openSideCart } from '../common/side-cart/side-cart';
import { addItems } from '../../scripts/cartApi';

class QuizResultsController {
  static init() {
    return new QuizResultsController();
  }

  constructor() {
    this.selectors = {
      packTitle: '[data-collection-quiz-results-hero-pack-title]',
      showPackTitleAttr: 'data-show',
      quantityPanelSelector: '[data-products-type-tile-quantity]',
      decrementSelector: '[data-products-type-tile-quantity-decrement]',
      incrementSelector: '[data-products-type-tile-quantity-increment]',
      quantityNumberSelector: '[data-products-type-tile-quantity-count]',
      productItemSelector: '[data-products-type-tile]',
      collapsibleButtonSelector: '[data-products-type-tile-collapsible-button]',
      totalPriceSelector: '[data-collection-quiz-results-total-price]',
      addToCartSelector: '[data-collection-quiz-results-total-add-to-cart]',
      soldOutSelector: '[data-product-type-caption-sold-out-text]',
      inventoryQuantityAttr: 'data-product-inventory-quantity',
      inventoryPolicyAttr: 'data-product-inventory-policy',
    };

    this.els = {
      packTitles: document.querySelectorAll(this.selectors.packTitle),
      quantityPanels: document.querySelectorAll(
        this.selectors.quantityPanelSelector
      ),
      productItems: [
        ...document.querySelectorAll(this.selectors.productItemSelector),
      ],
      totalPrice: document.querySelector(this.selectors.totalPriceSelector),
      addToCart: document.querySelector(this.selectors.addToCartSelector),
    };

    this.totalPrice = 0;

    this.addEventListeners();

    this.initParams();
    this.initState();
  }

  initParams() {
    const params = new URLSearchParams(window.location.search);

    this.roomSize = params.get('size');
  }

  initState() {
    const { showPackTitleAttr } = this.selectors;
    const { packTitles, productItems } = this.els;

    packTitles.forEach((titleElem) => {
      if (titleElem.dataset.sizeRoom === this.roomSize) {
        titleElem.setAttribute(showPackTitleAttr, 'true');
      }
    });

    productItems.forEach((item) => {
      switch (item.dataset.productTag) {
        case 'two-switch': {
          this.initControls(item);
          break;
        }

        case 'Switch': {
          this.initSwitches(item);
          break;
        }

        case 'Plug': {
          this.initPlug(item);
          break;
        }

        default:
          break;
      }
    });

    this.initTotalPrice();
  }

  initControls(item) {
    const { quantityNumberSelector, soldOutSelector, inventoryQuantityAttr } =
      this.selectors;
    const quantityNumberNode = item.querySelector(quantityNumberSelector);
    const soldOutEl = item.querySelector(soldOutSelector);
    const availableInventoryQuantity = item.getAttribute(inventoryQuantityAttr);

    if (quantityNumberNode) {
      switch (this.roomSize) {
        case 'studio': {
          if (this.isVariantInStock(item, '1')) {
            quantityNumberNode.innerHTML = '1';
          } else {
            quantityNumberNode.innerHTML = '0';
            this.calcSoldOutText(soldOutEl, item);
          }
          break;
        }

        case 'small': {
          if (this.isVariantInStock(item, '2')) {
            quantityNumberNode.innerHTML = '2';
          } else {
            quantityNumberNode.innerHTML = availableInventoryQuantity;
            this.calcSoldOutText(soldOutEl, item);
          }
          break;
        }

        case 'medium': {
          if (this.isVariantInStock(item, '3')) {
            quantityNumberNode.innerHTML = '3';
          } else {
            quantityNumberNode.innerHTML = availableInventoryQuantity;
            this.calcSoldOutText(soldOutEl, item);
          }
          break;
        }

        case 'large': {
          if (this.isVariantInStock(item, '4')) {
            quantityNumberNode.innerHTML = '4';
          } else {
            quantityNumberNode.innerHTML = availableInventoryQuantity;
            this.calcSoldOutText(soldOutEl, item);
          }
          break;
        }

        default:
          break;
      }

      this.updateViews(item, quantityNumberNode);
    }
  }

  initSwitches(item) {
    const { quantityNumberSelector, soldOutSelector, inventoryQuantityAttr } =
      this.selectors;
    const quantityNumberNode = item.querySelector(quantityNumberSelector);
    const soldOutEl = item.querySelector(soldOutSelector);
    const availableInventoryQuantity = item.getAttribute(inventoryQuantityAttr);

    if (quantityNumberNode) {
      switch (this.roomSize) {
        case 'studio': {
          if (this.isVariantInStock(item, '3')) {
            quantityNumberNode.innerHTML = '3';
          } else {
            quantityNumberNode.innerHTML = availableInventoryQuantity;
            this.calcSoldOutText(soldOutEl, item);
          }
          break;
        }

        case 'small': {
          if (this.isVariantInStock(item, '6')) {
            quantityNumberNode.innerHTML = '6';
          } else {
            quantityNumberNode.innerHTML = availableInventoryQuantity;
            this.calcSoldOutText(soldOutEl, item);
          }
          break;
        }

        case 'medium': {
          if (this.isVariantInStock(item, '10')) {
            quantityNumberNode.innerHTML = '10';
          } else {
            quantityNumberNode.innerHTML = availableInventoryQuantity;
            this.calcSoldOutText(soldOutEl, item);
          }
          break;
        }

        case 'large': {
          if (this.isVariantInStock(item, '20')) {
            quantityNumberNode.innerHTML = '20';
          } else {
            quantityNumberNode.innerHTML = availableInventoryQuantity;
            this.calcSoldOutText(soldOutEl, item);
          }
          break;
        }

        default:
          break;
      }

      this.updateViews(item, quantityNumberNode);
    }
  }

  initPlug(item) {
    const { quantityNumberSelector, soldOutSelector, inventoryQuantityAttr } =
      this.selectors;
    const quantityNumberNode = item.querySelector(quantityNumberSelector);
    const soldOutEl = item.querySelector(soldOutSelector);
    const availableInventoryQuantity = item.getAttribute(inventoryQuantityAttr);

    if (quantityNumberNode) {
      switch (this.roomSize) {
        case 'studio': {
          if (this.isVariantInStock(item, '1')) {
            quantityNumberNode.innerHTML = '1';
          } else {
            this.calcSoldOutText(soldOutEl, item);
            quantityNumberNode.innerHTML = '0';
          }
          break;
        }

        case 'small': {
          if (this.isVariantInStock(item, '1')) {
            quantityNumberNode.innerHTML = '1';
          } else {
            quantityNumberNode.innerHTML = '0';
            this.calcSoldOutText(soldOutEl, item);
          }
          break;
        }

        case 'medium': {
          if (this.isVariantInStock(item, '2')) {
            quantityNumberNode.innerHTML = '2';
          } else {
            quantityNumberNode.innerHTML = availableInventoryQuantity;
            this.calcSoldOutText(soldOutEl, item);
          }
          break;
        }

        case 'large': {
          if (this.isVariantInStock(item, '4')) {
            quantityNumberNode.innerHTML = '4';
          } else {
            quantityNumberNode.innerHTML = availableInventoryQuantity;
            this.calcSoldOutText(soldOutEl, item);
          }
          break;
        }

        default:
          break;
      }

      this.updateViews(item, quantityNumberNode);
    }
  }

  updateProductCollapsable(product) {
    const { quantityNumberSelector, collapsibleButtonSelector } =
      this.selectors;
    const quantityNumberNode = product.querySelector(quantityNumberSelector);
    const collapsibleBtn = product.querySelector(collapsibleButtonSelector);

    if (quantityNumberNode.innerHTML > 0) {
      collapsibleBtn.classList.add(
        'products-type-tile__collapsible-button--hidden'
      );

      if (product.classList.contains('products-type-tile--close')) {
        product.classList.remove('products-type-tile--close');
      }
    } else if (
      collapsibleBtn.classList.contains(
        'products-type-tile__collapsible-button--hidden'
      )
    ) {
      collapsibleBtn.classList.remove(
        'products-type-tile__collapsible-button--hidden'
      );
    }
  }

  updateViews(product, quantityNumberNode) {
    updateQuantityColor(quantityNumberNode);
    this.updateProductCollapsable(product);

    function updateQuantityColor(quantityNode) {
      if (
        quantityNode.innerHTML > 0 &&
        quantityNode.classList.contains(
          'products-type-tile__quantity-count--blue'
        )
      ) {
        quantityNode.classList.remove(
          'products-type-tile__quantity-count--blue'
        );
      } else if (
        +quantityNode.innerHTML === 0 &&
        !quantityNode.classList.contains(
          'products-type-tile__quantity-count--blue'
        )
      ) {
        // eslint-disable-next-line no-unused-expressions
        !quantityNode.classList.add('products-type-tile__quantity-count--blue');
      }
    }
  }

  initTotalPrice() {
    const { quantityNumberSelector } = this.selectors;
    const { productItems, totalPrice } = this.els;

    productItems.forEach((product) => {
      const quantityNumberNode = product.querySelector(quantityNumberSelector);

      if (quantityNumberNode.innerHTML > 0) {
        this.totalPrice +=
          product.dataset.productPrice * quantityNumberNode.innerHTML;
      }
    });

    setTimeout(() => {
      totalPrice.innerHTML = formatPriceWithoutZeros(this.totalPrice);
    }, 500);
  }

  isVariantInStock(item, quantity) {
    const { inventoryQuantityAttr, inventoryPolicyAttr } = this.selectors;
    const productInventoryQuantity = item.getAttribute(inventoryQuantityAttr);
    const productInventoryPolicy = item.getAttribute(inventoryPolicyAttr);

    return (
      Number(productInventoryQuantity) >= quantity ||
      productInventoryPolicy === 'continue'
    );
  }

  calcSoldOutText(soldOutEl, item) {
    if (!item) {
      soldOutEl.setAttribute('data-show', 'false');

      return;
    }
    const { inventoryQuantityAttr } = this.selectors;
    const availableQuantity = item?.getAttribute(inventoryQuantityAttr) || 0;

    soldOutEl.setAttribute('data-show', 'true');
    if (Number(availableQuantity) < 1) {
      soldOutEl.innerHTML = 'Sold Out';
    } else {
      soldOutEl.innerHTML = `Available only ${availableQuantity} ${
        availableQuantity > 1 ? 'items' : 'item'
      }`;
    }
  }

  addEventListeners() {
    const { productItems, totalPrice, addToCart } = this.els;
    const {
      incrementSelector,
      decrementSelector,
      quantityNumberSelector,
      quantityPanelSelector,
      collapsibleButtonSelector,
      productItemSelector,
      soldOutSelector,
    } = this.selectors;

    productItems.forEach((productItem) => {
      const quantityPanel = productItem.querySelector(quantityPanelSelector);
      const collapsibleBtn = productItem.querySelector(
        collapsibleButtonSelector
      );
      const soldOutEl = productItem.querySelector(soldOutSelector);

      if (quantityPanel) {
        quantityPanel.addEventListener('click', (event) => {
          const { target } = event;

          if (
            target.closest(incrementSelector) &&
            !productItem.classList.contains('products-type-tile--close')
          ) {
            const quantityNumberNode = quantityPanel.querySelector(
              quantityNumberSelector
            );

            if (quantityNumberNode) {
              const newQuantity = +quantityNumberNode.innerHTML + 1;

              if (!this.isVariantInStock(productItem, newQuantity)) {
                this.calcSoldOutText(soldOutEl, productItem);
                return;
              }

              quantityNumberNode.innerHTML = newQuantity;

              this.totalPrice += +productItem.dataset.productPrice;
              totalPrice.innerHTML = formatPriceWithoutZeros(this.totalPrice);

              this.updateViews(productItem, quantityNumberNode);

              sendQuizStepEvent(
                QUIZ_EVENT_CATEGORY.INTERACTION,
                ACTIONS.ADD,
                PRODUCTS.productTagsAndTypes[productItem.dataset.productTag]
              );
            }
          } else if (
            target.closest(decrementSelector) &&
            !productItem.classList.contains('products-type-tile--close')
          ) {
            const quantityNumberNode = quantityPanel.querySelector(
              quantityNumberSelector
            );

            if (quantityNumberNode && quantityNumberNode.innerHTML > 0) {
              const newQuantity = +quantityNumberNode.innerHTML - 1;

              if (this.isVariantInStock(productItem, newQuantity)) {
                this.calcSoldOutText(soldOutEl, null);
              }

              quantityNumberNode.innerHTML = newQuantity;

              this.totalPrice -= productItem.dataset.productPrice;
              totalPrice.innerHTML = formatPriceWithoutZeros(this.totalPrice);

              this.updateViews(productItem, quantityNumberNode);

              sendQuizStepEvent(
                QUIZ_EVENT_CATEGORY.INTERACTION,
                ACTIONS.REMOVE,
                PRODUCTS.productTagsAndTypes[productItem.dataset.productTag]
              );
            }
          }
        });
      }

      productItem.addEventListener('click', (event) => {
        if (
          event.target.closest(productItemSelector) &&
          productItem.classList.contains('products-type-tile--close')
        ) {
          productItem.classList.remove('products-type-tile--close');
        }
      });

      if (collapsibleBtn) {
        collapsibleBtn.addEventListener('click', (event) => {
          event.stopPropagation();

          productItem.classList.toggle('products-type-tile--close');
        });
      }
    });

    addToCart.addEventListener('click', async () => {
      addToCart.setAttribute('data-loading', 'true');

      await initCart();

      const productsList = productItems.reduce((products, currentProduct) => {
        const { productId } = currentProduct.dataset;
        const quantity = +currentProduct.querySelector(quantityNumberSelector)
          .innerHTML;

        if (productId && quantity) {
          return [...products, { id: productId, quantity }];
        }

        return products;
      }, []);

      addToCart.setAttribute('data-loading', 'false');

      addItems(productsList)
        .then(() => {
          const { sideCart } = window;

          sideCart.updateView(null, openSideCart);
          addToCart.setAttribute('data-loading', 'false');
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }
}

window.onReady(() => {
  QuizResultsController.init();
});
